import { render, staticRenderFns } from "./timeInfo.vue?vue&type=template&id=12b54e96&scoped=true&"
import script from "./timeInfo.vue?vue&type=script&lang=js&"
export * from "./timeInfo.vue?vue&type=script&lang=js&"
import style0 from "./timeInfo.vue?vue&type=style&index=0&id=12b54e96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b54e96",
  null
  
)

export default component.exports